export default function BollywoodRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ol {
                        list-style-type: decimal;
                        padding-left: 40px;
                    }
                    #market-rules-text ol li {
                        list-style: list-item !important;
                    }
                `}
            </style>


            <div class="modal fade show" style={{ display: "block", paddingLeft: "0px", marginBottom: "20px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Bollywood Casino</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">
                                                The game of Bollywood Casino is a game of one card. The objective is to predict that of which section the dealt card will be. The sections are Don, Amar Akbar Anthony, Sahib Bibi aur Ghulam, Dharam veer, Kis Kisko Pyaar Karoon and Ghulam.
                                            </p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p>The game of Bollywood Casino is played with a total of 32 cards from two standard 52-cards Deck. The cards are the four Jacks, Queens, Kings and Aces from each Deck.</p>
                                            <p class="pt20">If the card is <b> (Ace of Spades)</b> Don wins.</p>
                                            <p class="pt20">If the card is <b> Ace of (Hearts,Clubs,Diamonds)</b> Amar Akbar Anthony wins.</p>
                                            <p class="pt20">
                                                If the card is <b> (King , Queen , Jack of Spades) </b> Sahib Bibi aur Ghulam wins.
                                            </p>
                                            <p class="pt20">
                                                If the card is <b> (King of Diamonds <b>OR</b> Clubs)</b> Dharam Veer wins.
                                            </p>
                                            <p class="pt20">
                                                If the card is <b> ( King of Hearts) OR (Queen of Clubs , Diamonds , Hearts) </b> Kis Kisko Pyaar Karoon wins.
                                            </p>
                                            <p class="pt20">If the card is <b>  Jack of (Hearts , Diamonds , Clubs) </b> Ghulam wins.</p>
                                        </div>
                                    </center>

                                    <div style={{ textAlign: "left" }}>
                                        <center>
                                            <h5>Main Bets</h5>
                                        </center>
                                        <ol>
                                            <li class="lit20">Don</li>
                                            <li class="lit20">Amar Akbar Anthony</li>
                                            <li class="lit20">Sahib Bibi aur Ghulam </li>
                                            <li class="lit20">Dharam Veer</li>
                                            <li class="lit20">Kis Kisko Pyaar Karoon</li>
                                            <li class="lit20">Ghulam</li>
                                        </ol>
                                    </div>

                                    <div style={{ textAlign: "left" }}>
                                        <center>
                                            <h5>Side Bets</h5>
                                        </center>
                                        <ol>
                                            <li class="lit20">Pair K-Q </li>
                                            <li class="lit20">Pair J-A</li>
                                            <li class="lit20">Black </li>
                                            <li class="lit20">Red</li>
                                            <li class="lit20">Cards - J</li>
                                            <li class="lit20">Cards - Q</li>
                                            <li class="lit20">Cards - K</li>
                                            <li class="lit20">Cards - A</li>

                                        </ol>
                                    </div>

                                    <div style={{ textAlign: "left" }}>
                                        <center><h3><b>PAYOUT</b></h3></center>
                                        <p class="pt20">
                                            Payout as per the bet placed
                                        </p>
                                        <div>
                                            <div>
                                                <table class="table table-bordered table-sm">
                                                    <thead>
                                                        <tr><th>Hands</th>
                                                            <th>Payout</th>
                                                        </tr></thead>
                                                    <tbody>
                                                        <tr>
                                                            <th>Pair K-Q</th>
                                                            <th>1: 0.97</th>
                                                        </tr>
                                                        <tr>
                                                            <th>Pair J-A</th>
                                                            <th>1: 0.97</th>
                                                        </tr>

                                                        <tr>
                                                            <th>Black</th>
                                                            <th>1: 0.97</th>
                                                        </tr>

                                                        <tr>
                                                            <th>Red</th>
                                                            <th>1: 0.97</th>
                                                        </tr>

                                                        <tr>
                                                            <th>Cards - J</th>
                                                            <th>1: 2.75</th>
                                                        </tr>

                                                        <tr>
                                                            <th>Cards - Q</th>
                                                            <th>1: 2.75</th>
                                                        </tr>

                                                        <tr>
                                                            <th>Cards - K</th>
                                                            <th>1: 2.75</th>
                                                        </tr>
                                                        <tr>
                                                            <th>Cards - A</th>
                                                            <th>1: 2.75</th>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
